module.exports = __webpack_public_path__ + "static/media/leaf.93fd6c01.png";